import React, { Component, CSSProperties, Fragment } from "react";
import "./App.css";
import ReactTooltip from "react-tooltip";
import { PermWeaponsData } from "./Models/APIPermWeaponsResponse";
import { loadStripe } from "@stripe/stripe-js/pure";
import {
  ProcessStripeTranscation,
  StripeCheckoutSessionDetails,
} from "./Helpers/StripeProcesser";
import { resolve } from "./Helpers/HelpResolveSteamid64";
import { ProcessPaypalTranscation } from "./Helpers/PaypalProcesser";
import { ProcessXSollaTransaction } from "./Helpers/XSollaProcesser";

type InputEvent = React.ChangeEvent<HTMLInputElement>;

type MyState = {
  steamid64: string;
  disabled: boolean;
  RankSelected: string;
  PermWep1: string;
  ShowPermWep2: Boolean;
  PermWep2: string;
  PermWeapons: string[];
  WeaponsToShow: string[];
  steamid64style: CSSProperties;
  RankStyle: CSSProperties;
  PermWeapon1Style: CSSProperties;
  PermWeapon2Style: CSSProperties;
  PaidFor: Boolean;
  Error: string | null;
  permweapons: PermWeaponsData | null;
  Formatted: string | null;
  PaymentProcessing: boolean;
};
type MyProps = {};
class App extends Component<MyProps, MyState> {
  constructor(props: any) {
    super(props);
    //this.handleSearchChange = this.handleSearchChange.bind(this);

    const urlParams = new URLSearchParams(window.location.search);
    let steamid64 = urlParams.get("steamid64");
    //console.log(steamid64);}
    this.state = {
      steamid64: steamid64 == null ? "" : steamid64,
      disabled: true,
      RankSelected: "Select Your Rank Or Upgrade",
      PermWep1: "Select Your Permanent Weapon #1",
      PermWep2: "Select Your Permanent Weapon #2",
      ShowPermWep2: false,
      PermWeapons: [],
      WeaponsToShow: [],
      steamid64style: {},
      RankStyle: {},
      PermWeapon1Style: {},
      PermWeapon2Style: {},
      PaidFor: false,
      Error: null,
      permweapons: null,
      Formatted:
        steamid64 !== null
          ? "Your SteamID64 has been auto filled. This value is public and unique to your steam account. You don't need to change it."
          : null,
      PaymentProcessing: false,
    };
    this.DebugLogCollectedPurchaseDetails = this.DebugLogCollectedPurchaseDetails.bind(
      this
    );
    this.HelpClearUpgradeError = this.HelpClearUpgradeError.bind(this);
    this.OnSteamIDInputChange = this.OnSteamIDInputChange.bind(this);
    this.OnRankSelectionChange = this.OnRankSelectionChange.bind(this);
    this.OnPermWeaponOneChange = this.OnPermWeaponOneChange.bind(this);
    this.OnPermWeaponTwoChange = this.OnPermWeaponTwoChange.bind(this);
    this.PermWeaponsToShow = this.PermWeaponsToShow.bind(this);
    this.ClickingOnDisabledButtons = this.ClickingOnDisabledButtons.bind(this);

    this.SubmitPaypal = this.SubmitPaypal.bind(this);
    this.SubmitStripe = this.SubmitStripe.bind(this);
    this.SubmitXsolla = this.SubmitXsolla.bind(this);
  }
  //Fix for clicking "Back" in the browser where it remembers your rank selection

  OnSteamLoginButtonClick(event: any) {
    if (typeof window === "undefined") {
      console.log("Document is null, probably SSR");
      return;
    }
    var GetButton = window.parent.document.getElementById("steamloginbtn");
    if (GetButton !== null) {
      GetButton.click();
    } else {
      console.log("Error: We failed finding the steamloginbutton");
    }
  }
  async SubmitPaypal(event: any) {
    if (this.state.disabled) {
      this.ClickingOnDisabledButtons();
      return;
    }
    if (this.state.PaymentProcessing) return;
    this.HelpClearUpgradeError();
    this.DebugLogCollectedPurchaseDetails();
    this.setState({ PaymentProcessing: true });
    try {
      console.log("Submit Paypal was clicked and is not disabled");

      const sessionresponse: StripeCheckoutSessionDetails = await ProcessPaypalTranscation(
        this.state.RankSelected,
        this.state.PermWep1,
        this.state.PermWep2,
        this.state.steamid64
      );
      if (sessionresponse.id === null || sessionresponse.id === undefined) {
        console.log(`ERROR: ${sessionresponse.message}`);
        this.setState({ Error: sessionresponse.message });
        return;
      }

      window.location.href = `https://www.paypal.com/checkoutnow?token=${sessionresponse.id}`;
    } catch (exception) {
      console.log("Error checking out");
      console.log(exception);
      //Sentry.captureException(exception);
    } finally {
      this.setState({ PaymentProcessing: false });
    }
  }
  async SubmitXsolla(event: any) {
    if (this.state.disabled) {
      this.ClickingOnDisabledButtons();
      return;
    }
    if (this.state.PaymentProcessing) return;
    this.HelpClearUpgradeError();
    this.DebugLogCollectedPurchaseDetails();
    this.setState({ PaymentProcessing: true });
    try {
      console.log("Submit XSolla was clicked and is not disabled");
      const sessionresponse: StripeCheckoutSessionDetails = await ProcessXSollaTransaction(
        this.state.RankSelected,
        this.state.PermWep1,
        this.state.PermWep2,
        this.state.steamid64
      );

      var options = {
        access_token: sessionresponse.id,
        sandbox: false,
      };
      if (typeof window === "undefined") {
        console.log("Document is null, probably SSR");
        return;
      }
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "//static.xsolla.com/embed/paystation/1.0.7/widget.min.js";
      s.addEventListener(
        "load",
        function (e) {
          // @ts-ignore
          XPayStationWidget.init(options);
          // @ts-ignore
          XPayStationWidget.open();
        },
        false
      );
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(s);

      if (sessionresponse.id === null || sessionresponse.id === undefined) {
        console.log(`ERROR: ${sessionresponse.message}`);
        this.setState({ Error: sessionresponse.message });
        return;
      }
    } catch (exception) {
      console.log("Error checking out");
      console.log(exception);
      //Sentry.captureException(exception);
    } finally {
      this.setState({ PaymentProcessing: false });
    }
  }
  async SubmitStripe(event: any) {
    if (this.state.disabled) {
      this.ClickingOnDisabledButtons();
      return;
    }
    if (this.state.PaymentProcessing) return;
    this.HelpClearUpgradeError();
    this.DebugLogCollectedPurchaseDetails();
    this.setState({ PaymentProcessing: true });
    try {
      console.log("Submit Stripe was clicked and is not disabled");
      const sessionresponse: StripeCheckoutSessionDetails = await ProcessStripeTranscation(
        this.state.RankSelected,
        this.state.PermWep1,
        this.state.PermWep2,
        this.state.steamid64
      );
      if (sessionresponse.id === null || sessionresponse.id === undefined) {
        console.log(`ERROR: ${sessionresponse.message}`);
        this.setState({ Error: sessionresponse.message });
        return;
      }

      const stripePromise = loadStripe(
        "pk_live_51HHMeALFaiefOKTwQC2Tg43xwuXkoS71UaCpYD3bnCnRZBjb2dSFugPWps6EfEWoyORjZ6jLTfk5tcsvZ2phlWd100lsE16jPT"
      );
      // When the customer clicks on the button, redirect them to Checkout.
      const stripe = await stripePromise;

      if (stripe === null) {
        console.log(`Error contacting stripe`);
        this.setState({
          Error: "Error Contacting Stripe, try refreshing or contact us",
        });

        return;
      }

      console.log(`Submitting ${sessionresponse.id} to stripe`);
      const { error } = await stripe.redirectToCheckout({
        sessionId: sessionresponse.id,
      });
      if (error) {
        console.log(`Error occured with stripe ${error.message}`);
        this.setState({
          Error: "Error Contacting Stripe, try refreshing or contact us",
        });
      }
    } catch (exception) {
      console.log("Error checking out");
      console.log(exception);
      //Sentry.captureException(exception);
    } finally {
      this.setState({ PaymentProcessing: false });
    }
  }
  DebugLogCollectedPurchaseDetails() {
    console.log(`Purchase Details:`);
    console.log(`Rank Selected: ${this.state.RankSelected}`);
    console.log(`Perm Weapon 1: ${this.state.PermWep1}`);
    console.log(`Perm Weapon 2: ${this.state.PermWep2}`);
    console.log(`Steamid64 Entered: ${this.state.steamid64}`);
  }
  CheckIfSelectionsValid() {
    if (
      this.state.steamid64.length !== 0 &&
      this.state.RankSelected !== "base" &&
      this.state.RankSelected !== "Select Your Rank Or Upgrade" &&
      this.state.PermWep1 !== "Select Your Permanent Weapon #1" &&
      (this.state.ShowPermWep2 === false ||
        this.state.PermWep2 !== "Select Your Permanent Weapon #2")
    ) {
      if (this.state.disabled === true) {
        this.setState({ disabled: false });
      }
    } else {
      if (this.state.disabled === false) {
        this.setState({ disabled: true });
      }
    }
  }
  async OnSteamIDInputChange(event: InputEvent) {
    var input = event.target.value;
    var steamid64 = await resolve(input);
    this.setState(
      {
        steamid64: steamid64,
        Formatted:
          input !== steamid64
            ? "Automatically converted your input to a valid steamid64."
            : null,
      },
      () => {
        this.CheckIfSelectionsValid();
        if (this.state.steamid64style !== {}) {
          this.setState({ steamid64style: {} });
        }
      }
    );
  }
  OnRankSelectionChange(event: any) {
    this.setState({ RankSelected: event.target.value }, () => {
      this.PermWeaponsToShow();
      this.CheckIfSelectionsValid();
      if (
        this.state.RankStyle !== {} &&
        this.state.RankSelected !== "base" &&
        this.state.RankSelected !== "Select Your Rank or Upgrade"
      ) {
        this.setState({ RankStyle: {} });
      }
      if (this.state.RankSelected.toLowerCase().includes("upgrade")) {
        this.setState({
          Error:
            "Please note that when upgrading, you get the difference in Bamboo (credits) between your previous rank and the Upgraded rank.",
        });
      } else {
        this.HelpClearUpgradeError();
      }
    });
  }
  HelpClearUpgradeError() {
    if (
      this.state.Error ===
      "Please note that when upgrading, you get the difference in Bamboo (credits) between your previous rank and the Upgraded rank."
    ) {
      this.setState({ Error: null });
    }
  }
  OnPermWeaponOneChange(event: any) {
    var weapon = event.target.value;
    this.setState({ PermWep1: weapon }, () => {
      this.CheckIfSelectionsValid();
    });
    if (this.state.PermWeapon1Style !== {}) {
      this.setState({ PermWeapon1Style: {} });
    }
  }
  OnPermWeaponTwoChange(event: any) {
    this.setState({ PermWep2: event.target.value }, () => {
      this.CheckIfSelectionsValid();
    });
    if (this.state.PermWeapon2Style !== {}) {
      this.setState({ PermWeapon2Style: {} });
    }
  }
  GrabWeaponsviaAPI(): Promise<PermWeaponsData> {
    return fetch("https://pandahut.net/jsonselect/dataselect.json")
      .then((res) => res.json())
      .then((result: PermWeaponsData) => {
        return result;
      });
  }
  GetCSSForBlinkingButton(): CSSProperties {
    return {
      animation: "0.5s step-end 0s infinite alternate none running blink",
      border: "1px solid rgba(8, 8, 8, 0)",
    };
  }
  ClickingOnDisabledButtons() {
    if (this.state.disabled) {
      // Do the blinkining
      if (this.state.steamid64.length === 0) {
        this.setState({
          steamid64style: this.GetCSSForBlinkingButton(),
        });
      }
      if (
        this.state.RankSelected === "base" ||
        this.state.RankSelected === "Select Your Rank Or Upgrade"
      ) {
        this.setState({
          RankStyle: this.GetCSSForBlinkingButton(),
        });
      }

      if (
        this.state.PermWep1.length === 0 ||
        this.state.PermWep1 === "Select Your Permanent Weapon #1"
      ) {
        this.setState({
          PermWeapon1Style: this.GetCSSForBlinkingButton(),
        });
      }
      if (
        this.state.PermWep2.length === 0 ||
        this.state.PermWep2 === "Select Your Permanent Weapon #2"
      ) {
        this.setState({
          PermWeapon2Style: this.GetCSSForBlinkingButton(),
        });
      }
    }
  }
  async PermWeaponsToShow() {
    var permweapons: PermWeaponsData;
    if (
      this.state.permweapons === null ||
      this.state.permweapons === undefined
    ) {
      permweapons = await this.GrabWeaponsviaAPI();
      this.setState({ permweapons: permweapons });
    } else {
      permweapons = this.state.permweapons;
    }
    if (this.state.RankSelected.includes("MVP+")) {
      this.setState({
        WeaponsToShow: permweapons.mvpp.split(","),
        ShowPermWep2: true,
      });
    } else if (this.state.RankSelected.includes("MVP")) {
      this.setState({
        WeaponsToShow: permweapons.mvp.split(","),
        ShowPermWep2: false,
      });
    } else if (this.state.RankSelected.includes("VIP+")) {
      this.setState({
        WeaponsToShow: permweapons.vipp.split(","),
        ShowPermWep2: false,
      });
    } else if (this.state.RankSelected.includes("VIP")) {
      this.setState({
        WeaponsToShow: permweapons.vip.split(","),
        ShowPermWep2: false,
      });
    } else {
      this.setState({
        WeaponsToShow: [],
        ShowPermWep2: false,
      });
    }
  }

  render() {
    return (
      <div className="App">
        <div className="pp-div" id="donate">
          <table>
            <tbody>
              <tr>
                <td>Select your Desired Member Rank!</td>
              </tr>
              <tr>
                <td>
                  <select
                    className="jsonlist"
                    id="json-one"
                    name="os0"
                    value={this.state.RankSelected}
                    onChange={this.OnRankSelectionChange}
                    style={this.state.RankStyle}
                  >
                    <option value="Select Your Rank Or Upgrade" hidden>
                      Select Your Rank or Upgrade
                    </option>
                    <option value="VIP">
                      VIP &nbsp; &nbsp; &nbsp;$4.50 USD
                    </option>
                    <option value="VIP+">VIP+ &nbsp; &nbsp;$7.50 USD</option>
                    <option value="MVP"> MVP &nbsp; &nbsp;$15.00 USD</option>
                    <option value="MVP+">MVP+ &nbsp;$30.00 USD</option>
                    <option value="Upgrade: VIP to VIP+">
                      Upgrade: VIP to VIP+ &nbsp; &nbsp; &nbsp;&nbsp;$3.00 USD
                    </option>
                    <option value="Upgrade: VIP to MVP">
                      Upgrade: VIP to MVP &nbsp; &nbsp; &nbsp; $10.50 USD
                    </option>
                    <option value="Upgrade: VIP to MVP+">
                      Upgrade: VIP to MVP+ &nbsp; &nbsp; $25.50 USD
                    </option>
                    <option value="Upgrade: VIP+ to MVP">
                      Upgrade: VIP+ to MVP &nbsp; &nbsp; $7.50 USD
                    </option>
                    <option value="Upgrade: VIP+ to MVP+">
                      Upgrade: VIP+ to MVP+ &nbsp; $22.50 USD
                    </option>
                    <option value="Upgrade: MVP to MVP+">
                      Upgrade: MVP to MVP+ &nbsp;&nbsp;$15.00 USD
                    </option>
                  </select>{" "}
                </td>
              </tr>
              <tr>
                <td>
                  <input type="hidden" name="on2" value="Weapon" />
                  <select
                    name="os2"
                    id="json-two"
                    value={this.state.PermWep1}
                    onChange={this.OnPermWeaponOneChange}
                    style={this.state.PermWeapon1Style}
                  >
                    <option
                      value=""
                      key="Select Your Permanent Weapon #1"
                      hidden
                    >
                      Select Your Permanent Weapon #1
                    </option>
                    {this.state.WeaponsToShow.filter(
                      (item) => item !== this.state.PermWep2
                    ).map((item) => {
                      return (
                        <option value={item} key={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                </td>
              </tr>
              {this.state.ShowPermWep2 ? (
                <tr>
                  <td>
                    <input type="hidden" name="on3" value="Weapon2" />
                    <select
                      name="os3"
                      id="json-three"
                      className="secondpermwep"
                      value={this.state.PermWep2}
                      onChange={this.OnPermWeaponTwoChange}
                      style={this.state.PermWeapon2Style}
                    >
                      <option
                        value=""
                        key="Select Your Permanent Weapon #2"
                        hidden
                      >
                        Select Your Permanent Weapon #2
                      </option>
                      {this.state.WeaponsToShow.filter(
                        (item) => item !== this.state.PermWep1
                      ).map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                </tr>
              ) : null}
              <tr>
                <td>
                  <input type="hidden" name="on1" value="SteamID64" />
                  Enter Your 17-digit{" "}
                  <a
                    className="steamidlink"
                    target="_parent"
                    href="https://pandahut.net/steamid64/"
                  >
                    SteamID64
                  </a>
                  {this.state.Formatted != null ? (
                    <Fragment>
                      <div data-tip={this.state.Formatted} className="help-tip">
                        {" "}
                      </div>
                      <ReactTooltip place="top" type="dark" effect="float" />
                    </Fragment>
                  ) : null}
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    type="text"
                    className="steamid"
                    id="stid"
                    name="os1"
                    maxLength={200}
                    value={this.state.steamid64}
                    onChange={this.OnSteamIDInputChange}
                    style={this.state.steamid64style}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <sub>
                    If you don't know your Steamid64, login through Steam
                  </sub>
                  <div className="SteamLoginButton">
                    <div
                      className="steamlogin"
                      onClick={this.OnSteamLoginButtonClick}
                    ></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          {this.state.Error != null ? (
            <div>
              {" "}
              <h1>{this.state.Error} </h1>{" "}
            </div>
          ) : null}
          <div
            id="payment-area"
            style={
              this.state.PaymentProcessing
                ? { opacity: "0.5", pointerEvents: "none" }
                : undefined
            }
          >
            <button
              id="btnpaypal"
              className="btnpaypal"
              onClick={this.SubmitPaypal}
            ></button>
            <button
              id="btnstripe"
              className="btnstripe"
              onClick={this.SubmitStripe}
            ></button>
            {/* 
            <button
              id="btnxsolla"
              className="btnxsolla"
              onClick={this.SubmitXsolla}
            ></button>
            */}
          </div>
        </div>
      </div>
    );
  }
}

export default App;
